import React, { Fragment } from "react";
import {
  Container,
  Title,
  ImageDrop,
  EditButton,
  SubTitle,
  Description,
} from "./styles";

const Profile = () => {
  return (
    <Fragment>
      <Container>
        <Title>Olá, Fabrício!</Title>
        <ImageDrop />
        <EditButton>Editar dados de Cadastro</EditButton>
        <SubTitle>Editar descrição</SubTitle>
        <Description rows="9" />
      </Container>
    </Fragment>
  );
};

export default Profile;
